"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Member = exports.AccessLevel = void 0;
var AccessLevel;
(function (AccessLevel) {
    AccessLevel[AccessLevel["CONTRIBUTOR"] = 1] = "CONTRIBUTOR";
    AccessLevel[AccessLevel["REVIEWER"] = 2] = "REVIEWER";
    AccessLevel[AccessLevel["AUTHOR"] = 4] = "AUTHOR";
    AccessLevel[AccessLevel["EDITOR"] = 8] = "EDITOR";
    AccessLevel[AccessLevel["OWNER"] = 1024] = "OWNER";
    AccessLevel[AccessLevel["ADMIN"] = 65536] = "ADMIN";
})(AccessLevel = exports.AccessLevel || (exports.AccessLevel = {}));
var Member = /** @class */ (function () {
    function Member(_a) {
        var id = _a.id, memberName = _a.memberName, contact = _a.contact, swap = _a.swap, avatar = _a.avatar, accessLevel = _a.accessLevel;
        this.id = id;
        this.memberName = memberName;
        this.contact = contact;
        this.swap = swap;
        this.avatar = avatar;
        this.accessLevel = accessLevel;
    }
    return Member;
}());
exports.Member = Member;
//# sourceMappingURL=member.js.map